import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { Store } from '@ngxs/store';
import { 
  ToggleVisibleNodes,
  HideInverse,
  ToggleInversePickableNodes,
  CheckNode,
  CheckInverseNodes,
  SetCheckedNodes, 
  PaintNodes} from 'src/app/engine/state/nodes/engine.nodes.actions';
import { FlyToObject } from '../../../engine/state/engine.actions';
import { SetObjectVisibility, SetObjectPickable } from 'src/app/edit/state/edit.actions';
import { EngineState } from '../../../engine/state/engine.state';
import { EngineNodesState } from '../../../engine/state/nodes/engine.nodes.state';
import { EnvironmentApplication } from 'src/environments/models/environment-application';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { PaintPresetFade } from '../../../engine/models/paint-presets.const';

@Component({
  selector: 'app-node-actions',
  templateUrl: './node-actions.component.html',
  styleUrls: ['./node-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NodeActionsComponent implements OnInit {
  application = EnvironmentApplication;

  @Input()
  node: ViewTreeNode;

  @Input()
  theme: 'light' | 'dark' = 'dark';

  constructor(
    private store: Store,
    private graphService: BdGraphService,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  isChecked(node) {
    return this.store.selectSnapshot(EngineNodesState.getCheckedNodes)
      .some(checkedNode => checkedNode.id === node.id);
  }

  checkNode(node: ViewTreeNode, checked?: boolean) {
    if (typeof checked === 'undefined') {
      // When not explicitly defiend, toggle the node checked state
      checked = !this.isChecked(node);  
    }

    this.store.dispatch(new CheckNode(node, checked));
  }

  checkInverse(node) {
    this.store.dispatch(new CheckInverseNodes([node]));
  }

  setCheckedNodes(node: ViewTreeNode, checked?: boolean) {
    if (typeof checked === 'undefined') {
      // When not explicitly defiend, toggle the node checked state
      checked = !this.isChecked(node);  
    }
 
    const nodes = checked ? [node] : [];
    this.store.dispatch(new SetCheckedNodes(nodes));
  }

  flyToNode(node: ViewTreeNode) {
    this.store.dispatch(new FlyToObject(node.id));
  }
  
  hideNode(node: ViewTreeNode) {
    this.store.dispatch(new SetObjectVisibility([node], false));
  }

  hideInverse(node: ViewTreeNode) {
    const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
    this.store.dispatch(new HideInverse([node], viewGraph));
  }
  
  showNode(node: ViewTreeNode) {
    this.store.dispatch(new SetObjectVisibility([node], true));
    this.changeDetectorRef.markForCheck();
  }

  toggleVisible(node: ViewTreeNode, show?: boolean) {
    show = (typeof show === 'undefined') ? !node.boolState.shown : show;
    this.store.dispatch(new ToggleVisibleNodes([node], show));
    this.changeDetectorRef.markForCheck();
  }

  togglePickable(node: ViewTreeNode, pickable: boolean) {
    this.store.dispatch(new SetObjectPickable([node], pickable));
    this.changeDetectorRef.markForCheck();
  }

  toggleInversePickable(node: ViewTreeNode, pickable: boolean) {
    const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
    this.store.dispatch(new ToggleInversePickableNodes([node], viewGraph, pickable));    
  }

  fadeInverseNodes(node: ViewTreeNode) {
    const viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
    const inverseNodeIds = this.graphService.getInverseSelection(viewGraph, [node.id]);
    const nodes = this.graphService.getNodes(viewGraph, inverseNodeIds);
  
    this.store.dispatch(new PaintNodes(nodes, PaintPresetFade.recipe));
  }

  fadeNode(node: ViewTreeNode) {
    this.store.dispatch(new PaintNodes([node], PaintPresetFade.recipe));
  }
}
